import { api } from "./api/client";
import type { Id, SmartAlert, WatchlistItem, WatchlistSugerencia } from "@/types";

export const watchlistService = {
  list: async (): Promise<WatchlistItem[]> =>
    (await api.get<WatchlistItem[]>("/watchlist")).data,

  add: async (item: { kind: WatchlistItem["kind"]; valor: string }): Promise<WatchlistItem> =>
    (await api.post<WatchlistItem>("/watchlist", item)).data,

  setActivo: async (id: Id, activo: boolean): Promise<WatchlistItem> =>
    (await api.patch<WatchlistItem>(`/watchlist/${id}`, { activo })).data,

  remove: async (id: Id): Promise<{ ok: true }> =>
    (await api.delete<{ ok: true }>(`/watchlist/${id}`)).data,

  alerts: async (): Promise<SmartAlert[]> =>
    (await api.get<SmartAlert[]>("/watchlist/alerts")).data,

  sugerencias: async (): Promise<WatchlistSugerencia[]> =>
    (await api.get<WatchlistSugerencia[]>("/watchlist/sugerencias")).data,
};
